export default __webpack_public_path__ + "85ea9ade15278afa928609a478f58fcb.png";